import { useTranslation } from 'next-i18next'

import { Tag } from '../types/bootcamp.types'

const GRADIENT = {
  [Tag.NEW]: 'from-[#F73835] to-[#F9992C]',
  [Tag.UPDATED]: 'from-pink-logo to-[#B073FF]',
  [Tag.COMING_SOON]: '',
}

const BootcampStatusTag = ({ status, className = '' }: { status?: Tag; className?: string }): React.ReactElement => {
  const { t } = useTranslation('bootcamp')

  const gradient = status ? GRADIENT[status] : ''

  return (
    <span
      className={`text-xxs px-1.5 min-w-12 text-center whitespace-nowrap leading-5 font-semibold tracking-wider bg-gradient-to-r ${gradient} text-white rounded-full ${className}`}
      data-testid="bootcamp-status"
    >
      {t(`${status}`)}
    </span>
  )
}

export default BootcampStatusTag
